import qs from 'query-string';

type QueryStringValue = string | number | boolean | null | undefined;

interface QueryString {
  [key: string]: QueryStringValue | QueryStringValue[];
}

export function readQs(): QueryString {
  return { ...qs.parse(window.location.search, { parseBooleans: true, parseNumbers: true }) };
}

export function writeQs(queries: QueryString) {
  window.history.replaceState(null, '', `?${qs.stringify(queries)}`);
}

export function replaceQs(queries: QueryString) {
  window.location.search = qs.stringify(queries);
}

export function stringify(queries: QueryString): string {
  return qs.stringify(queries);
}

export default { readQs, writeQs, replaceQs, stringify };
